import { Helmet } from 'react-helmet-async';
// sections
import ClassesDetailsView from '../../../sections/classes/view/classes-details-view';
import { useLocales } from '../../../locales';

// ----------------------------------------------------------------------

export default function ClassesDetailsPage() {
  const { t } = useLocales();

  return (
    <>
      <Helmet>
        <title> {t('Dashboard: Class Details')}</title>
      </Helmet>

      <ClassesDetailsView />
    </>
  );
}
